import { render, staticRenderFns } from "./TicketBlockInfo.vue?vue&type=template&id=70340928"
import script from "./TicketBlockInfo.vue?vue&type=script&lang=js"
export * from "./TicketBlockInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports